import BreadCrumb from './BreadCrumb'
import DetailCard from './DetailCard'
import DetailContent from './DetailContent'
import CourseOutline from './CourseOutline'
import CourseParticulars from './CourseParticulars'
import DetailRight from './DetailRight'
import OperateLocation from './OperateLocation'

export default {
  BreadCrumb,
  DetailCard,
  DetailContent,
  CourseOutline,
  CourseParticulars,
  DetailRight,
  OperateLocation
}



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/index.js